export enum NotificationScopeEnum {
  ALL = "ALL",
  ADMIN = "ADMIN",
  USER = "USER",
  NONE = "NONE",
}
